import React, { useEffect, useState } from 'react';
import { get_ListeSite } from '../api/site';
import { message, Select } from 'antd';

const {Option} = Select
const ListeSite = ({ onchange, valeur}) => {

    const [ListeSite, setListeSite] = useState([])
    useEffect(() => {
        fetchSite()
        
       
    }, []);

    const fetchSite = async () => {
        const res = await get_ListeSite()
        if (res.status === 'success'){
            setListeSite(res.data)
        }else{
            message.warning("Erreur lors de la récuperation de la liste de sites", 2000)
        }
    }


    return (
        <div>
            <Select
                showSearch
                size = "medium"
                style = {{
                    width: "100%",
                    textAlign: "center"
                }}
                onChange={(value) => {
                    if(onchange) onchange(value)
                }}
                value={valeur && valeur !== 0 ? valeur : null} 
                placeholder="Choisir un site"
            >
                {
                    ListeSite && ListeSite.map(item =>{
                        return(
                            <Option key = {item.id} value = {item.id}>{item.nom}</Option>
                        )
                    })
                }

            </Select>
        </div>
    );
}

export default ListeSite;
